import { useMemo, useState } from "react";
import FlexColumn from "../../../../../../../../components/FlexBox/FlexColumn";
import FlexRow from "../../../../../../../../components/FlexBox/FlexRow";
import Typography from "../../../../../../../../components/Typography/Typography";
import { colors } from "../../../../../../../../styles/colors";
import { PlusIcon } from "@phosphor-icons/react";
import Board from "./Board";
import Divider from "../../../../../../../../components/Divider/Divider";
import SButton from "../../../../../../../../components/SButton/SButton";
import styles from '../../styles.module.scss';

const DownstreamBoard = ({ accessPointDetails, hNext, hBack, inProgress = false }) => {
    const [boards, setBoards] = useState([]);

    const boardChecks = useMemo(() => {
        let port1ChannelCount = 0;
        let port2ChannelCount = 0;
        let port1Count = 0;
        let port2Count = 0;
        for (let i = 0; i < boards?.length; i++) {
            const currBoard = boards[i];

            if (currBoard?.port === "1") {
                port1Count = port1Count + 1;
                port1ChannelCount = port1ChannelCount + Number(currBoard?.channels)
            } else {
                port2Count = port2Count + 1;
                port2ChannelCount = port1ChannelCount + Number(currBoard?.channels)
            }
        }
        return {
            totalChannels: port1ChannelCount + port2ChannelCount + accessPointDetails?.noOfControllerChannels,
            port1ChannelCount: port1ChannelCount,
            port2ChannelCount: port2ChannelCount,
            port1Count,
            port2Count
        }
    }, [accessPointDetails?.noOfControllerChannels, boards])

    const hAddBoard = () => {
        setBoards(prev => ([
            ...prev,
            {
                opened: true,
                port: "1",
                channels: "2"
            }
        ]))
    }

    const hUpdateBoard = (i, name, value) => {
        const tempBoards = [...boards]
        tempBoards[i][name] = value;
        setBoards(tempBoards)
    }

    const handleNext = () => {
        const toSend = {
            boards,
        }
        hNext && hNext(toSend);
    }

    return (
        <FlexColumn styles={{ marginTop: '1rem' }}>
            <FlexColumn alignItems="start" styles={{ marginBottom: '4rem' }}>
                <FlexRow flexWrap="nowrap">
                    <FlexColumn gap="0.4rem" alignItems="start">
                        <Typography variant={"b1B"}>Downstream Board</Typography>
                        <Typography variant={"b3R"} color={colors.grey400}>Add downstream boards for additional doors. Max 16 doors</Typography>
                    </FlexColumn>
                    <SButton disabled={boardChecks?.totalChannels >= 16} variant={"secondary"} style={{ width: '12rem' }} onClick={hAddBoard}>
                        <PlusIcon weight="bold" size={16} style={{ marginRight: '0.5rem' }} /> Add Board
                    </SButton>
                </FlexRow>
                <Divider />

                {boards?.map((b, i) => (<Board index={i} board={b} updateBoard={(name, value) => { hUpdateBoard(i, name, value) }} deleteBoard={() => { setBoards(prev => prev.filter((_, index) => i !== index)) }} />))}

                {boardChecks?.totalChannels > 16 ?
                    <Typography variant={"b3R"} color={colors.error500}>Total number of channels is greater then 16. {accessPointDetails?.noOfControllerChannels}(No of Channels) + {boardChecks?.port1ChannelCount + boardChecks?.port2ChannelCount}(Downstream Board Channels) = {boardChecks?.totalChannels}</Typography> :
                    (boardChecks?.port1ChannelCount > 8 || boardChecks?.port2ChannelCount > 8) ?
                        <Typography variant={"b3R"} color={colors.error500}>Each port supports up to 8 channels. {boardChecks?.port1ChannelCount > 8 ? "Port 1" : "Port 2"} has {boardChecks?.port1ChannelCount > 8 ? boardChecks?.port1ChannelCount : boardChecks?.port2ChannelCount} channels</Typography> :
                        (boardChecks?.port1Count > 1 || boardChecks?.port2Count > 1) ?
                            <Typography variant={"b3R"} color={colors.error500}>Only Borad can be added on each port</Typography> :
                            <></>
                }
            </FlexColumn>

            <FlexRow justifyContent="end" className={styles["fixed-actions"]}>
                <SButton disabled={inProgress} color={"grey"} minWidth onClick={() => { hBack && hBack(1) }}>Back</SButton>
                <SButton onClick={handleNext} minWidth disabled={inProgress || boardChecks?.totalChannels > 16 || (boardChecks?.port1ChannelCount > 8 || boardChecks?.port2ChannelCount > 8) || (boardChecks?.port1Count > 1 || boardChecks?.port2Count > 1)} >Save</SButton>
            </FlexRow>
        </FlexColumn>
    )
};

export default DownstreamBoard;